import type { ClientProps } from '@pages/Invoicing/context/types'
import type { OtherServicesItemProps } from '@pages/InvoicingClientModal/context/types'
import { formattedDatePtBr } from '@utils/dates/formattedDatePtBr'

export const setInitialValues = (data: OtherServicesItemProps, clientData?: ClientProps) => {
  return {
    clientName: clientData?.nomeCliente || data?.clientName || '',
    clientType: clientData?.tipoCliente || data?.clientType || '',
    clientCode: clientData?.cdClienteNl || data?.clientId || '',
    serviceDescription: data?.description || '',
    dateOfBilling: data?.billingStartDate ? formattedDatePtBr(data.billingStartDate) : '',
    grossUnitValue: data?.unitGrossValue?.toFixed(2) || '',
    tax: data?.billingTaxPercentage?.toFixed(2) || '',
    totalQuantity: data?.totalQuantity?.toString() || '',
    grossTotalValue: data?.grossTotalAmount?.toFixed(2) || '',
    netTotalValue: data?.netTotalAmount?.toFixed(2) || '',
    observations: data?.observations || ''
  }
}
